import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, catchError, tap, retry, switchMap } from 'rxjs/operators';
import { Observable, Subject, of, throwError, pipe } from 'rxjs';

import { Token } from './classes/Token';
import { environment } from 'src/environments/environment';
import { NotificationServiceHM } from './menu/notification-item/notification-item.service'
import { Area } from './interfaces/area';
import { User } from './interfaces/user';

@Injectable()

export class MainService {

     //public url = ' http://localhost:8080/api/v1';
     // public url_v2 = 'http://localhost:8080/api/v2'
    public url = environment.url_v1;
    public url_v1_v2 = environment.url_v1_v2;
    public url_v2 = environment.url_v2;

    public userToken = new Token();
    public workAreas: Array<any> = [ ];
    public httpOptions = {
        headers : new HttpHeaders ({
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'Authorization': this.userToken.token || 'tokeninvalido'
            })
        };
    public sUsername: string = '';
    public sToken: string = '';
    public sRoles: Array<any> = [ ];
    public valid_login = false;
    public limite_login: number = 0;
    public isDeveloper: boolean = false;
    public sessionAreaChanged = new Subject<void>();

    constructor( private _http: HttpClient,
        public notificationServiceHM: NotificationServiceHM) {
    }

    updateHeaders() {
        this.httpOptions = {
            headers : new HttpHeaders ({
                'Content-type': 'application/json',
                'Authorization': this.userToken.token
                })
            };
    }

    public validSession() {
        this.userToken.token = sessionStorage.getItem('Token') || '';
        this.userToken.role = sessionStorage.getItem('Role') || '';
        this.userToken.username = sessionStorage.getItem('User') || '';
        const storedArea = sessionStorage.getItem('Area');
        this.userToken.area = storedArea && storedArea !== 'undefined' ? storedArea : '';
        this.userToken.areaID = sessionStorage.getItem('AreaID') || '';
        this.userToken.tribeID = sessionStorage.getItem('TribeID') || '';
        this.userToken.tribeName = sessionStorage.getItem('Tribe') || '';
        this.sRoles = JSON.parse(sessionStorage.getItem('Roles') || '[]');
        this.isDeveloper = JSON.parse(sessionStorage.getItem('Developer') || 'false');
        if ( sessionStorage.getItem('LimiteLogin') ){
            let limit = sessionStorage.getItem('LimiteLogin') || '0';
            this.limite_login = parseInt( limit )
        } else {
            this.limite_login = 0;
        }
        
        this.updateHeaders()
    }

    public logout() {
        sessionStorage.removeItem('Token');
        sessionStorage.removeItem('Role');
        sessionStorage.removeItem('User');
        sessionStorage.removeItem('Area');
        sessionStorage.removeItem('AreaID');
        sessionStorage.removeItem('TribeID');
        sessionStorage.removeItem('Tribe');
        sessionStorage.removeItem('Roles');
        sessionStorage.removeItem('Developer');
        location.reload();
    }

    // - LOGIN -----------------------------------------------------------------------------------------------------
    getUsers (): Observable<any> {
        return this._http.get('/api/v2/users', this.httpOptions )
                    .pipe(
                            retry(3),
                            map(users => {
                                return users;
                            }),
                            catchError(this.handleError));
    }

    editUsers(user: User): Observable<any> {
        return this._http.put<any>('/api/v2/users', user, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    checkUserValid(username): Observable<any> {
        return this._http.get('/api/v2/users/check/' + username, this.httpOptions )
                    .pipe(
                        map((response) => response),
                        catchError((error) => {
                          if (error.status === 404) {
                            return of(error.error);
                          }
                          return throwError(() => error);
                        }));
    }

    createUser (username, password, role = 'user'): Observable<any> {
        return this._http.post<any>('/api/v2/users', JSON.stringify({username, password, roles: [role]}), this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getToken (username, password): Observable<any> {
        this.valid_login = this.checkLimitiLogin();
        if (!this.valid_login) {
            return this._http.post<any>('/api/v1/tokens', JSON.stringify({username, password}), this.httpOptions)
            .pipe(
                map(res => {
                    this.userToken.token = res.token;
                    this.userToken.role = this.checkMainRole(res.roles);
                    this.sRoles = res.roles;
                    this.userToken.area = res.area || '';
                    this.userToken.areaID = res.areaID || '';
                    this.userToken.restricted = res.restricted;
                    this.updateHeaders();
                    sessionStorage.setItem('Token', this.userToken.token);
                    sessionStorage.setItem('Role', this.userToken.role);
                    sessionStorage.setItem('User', this.userToken.username.toLowerCase());
                    sessionStorage.setItem('Area', this.userToken.area);
                    sessionStorage.setItem('AreaID', this.userToken.areaID);
                    sessionStorage.setItem('Restricted', this.userToken.restricted);
                    sessionStorage.setItem('Roles', JSON.stringify(res.roles));
                    return this.userToken.token;
            }),
                catchError(this.handleError)
        );
        } else {
            this.reportLimitAndCheckTimeout()
            return throwError(() => new Error('I have a bad feeling about this... 401 -> Limite de Logins Excedido1')) 
        }
        
    }

    getTokenV2 (username, password): Observable<any> {
        this.valid_login = this.checkLimitiLogin();
        if (!this.valid_login) {
            return this._http.post<any>('/api/v2/auth', JSON.stringify({username, password}), this.httpOptions)
            .pipe(
                map(res => {
                    return this.userToken.token;
            }),
                catchError(this.handleError)
        );
        } else {
            this.reportLimitAndCheckTimeout()
            return throwError(() => new Error('I have a bad feeling about this... 401 -> Limite de Logins Excedido2')) 
        }
        
    }

    checkDeveloper (sub?: string): Observable<any> {
        let url = '/api/v2/compile/developer/check';
        if (sub) {
            url += `?sub=${encodeURIComponent(sub)}`;
        }
        return this._http.get<any>(url, this.httpOptions)
            .pipe(
                map(res => {
                    // rota admin (com sub) checa outro usuario, nao altera a sessao atual
                    if (!sub) {
                        this.isDeveloper = !!res.developer;
                        sessionStorage.setItem('Developer', JSON.stringify(this.isDeveloper));
                    }
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    checkLimitiLogin() {
        let valid = false
        if ( sessionStorage.getItem('LimiteLogin') ){
            let limit = sessionStorage.getItem('LimiteLogin') || '0';
            this.limite_login = parseInt( limit )
            if (this.limite_login >= 6 ){
                valid = true;
            }
            console.log('limite atual', this.limite_login)
        } else {
            this.limite_login = 0;
        }
        return valid;

    }

    reportLimitAndCheckTimeout() {
        if ( sessionStorage.getItem('LimiteLogin_timestamp') ){
            console.log('chegou aqui no limit')
            let timestamp = sessionStorage.getItem('LimiteLogin_timestamp') || '0';
            let time_before = parseInt( timestamp )
            let hour_now = new Date().getTime()
            let timePass = new Date(hour_now - time_before).getUTCMinutes()
            let timeLeft = 5-timePass
            if ( timeLeft <= 0) {
                sessionStorage.removeItem('LimiteLogin_timestamp');
                sessionStorage.removeItem('LimiteLogin');
                this.limite_login = 0;
                this.valid_login = false;
                this.notificationServiceHM.showToast('Tente novamente realizar o login', 'warning');
            } else {
                this.notificationServiceHM.showToast('Limite de logins excedido! Próxima tentativa em ' +  timeLeft + ' minutos', 'error')
            }

        }

    }

    getPATAToken (): Observable<any> {
        return this._http.get('/api/v1/tokens/pata', this.httpOptions )
                    .pipe(
                            retry(3),
                            map(token => {
                                return token;
                            }),
                            catchError(this.handleError));
    }

    getCompileToken(): Observable<any> {
        return this._http.get('/api/v1/compile/token', this.httpOptions )
                    .pipe(
                        retry(3),
                        map(token => {
                            let compileKey: any = token;
                
                            let tmp = new Date();
                            tmp.setTime(compileKey.payload.exp * 1000);
                            compileKey.payload.exp = `${tmp.toLocaleString()}`;

                            tmp = new Date();
                            tmp.setTime(compileKey.payload.iat * 1000);
                            compileKey.payload.iat = `${tmp.toLocaleString()}`;
                            
                            return token;
                        }),
                        catchError(this.handleError));
    }

    getProfilePicture(): Observable<string> {
        // 1) Consulta o metadado da foto: o backend devolve o path relativo versionado
        //    (ex: /api/v2/users/profile-picture/raw?v=...) ou vazio quando não há foto.
        const silentHeaders = this.httpOptions.headers.set('X-PO-No-Message', 'true');
        return this._http.get<any>('/api/v2/users/profile-picture', { headers: silentHeaders }).pipe(
            switchMap((res) => {
                const path: string = res?.profilePicture || '';
                if (!path) {
                    return of('');
                }
                // 2) A rota /raw exige autenticação e o frontend usa Bearer no header. Como
                //    uma tag <img> não envia o header Authorization, buscamos os bytes via
                //    HttpClient (com o token) e devolvemos um object URL para renderizar.
                //    O path é relativo, então o proxy resolve o host (independe do
                //    PUBLIC_API_URL); o ?v= invalida o cache do blob quando a foto muda.
                return this._http.get(path, {
                    headers: new HttpHeaders({ 'Authorization': this.userToken.token, 'X-PO-No-Message': 'true' }),
                    responseType: 'blob'
                }).pipe(
                    map((blob: Blob) => (blob && blob.size > 0) ? URL.createObjectURL(blob) : '')
                );
            }),
            // Sem foto ou falha: retorna vazio silenciosamente para cair no avatar de iniciais.
            catchError(() => of(''))
        );
    }

    uploadProfilePicture(formData: FormData): Observable<any> {
        return this._http.post<any>('/api/v2/users/profile-picture/upload', formData, {
            headers: new HttpHeaders({
                'Authorization': this.userToken.token
            })
        }).pipe(
            catchError(this.handleError)
        );
    }

    deleteProfilePicture(): Observable<any> {
        return this._http.delete('/api/v2/users/profile-picture', this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    createPATAToken ( username, password ): Observable<any> {
        return this._http.post('/api/v1/tokens/pata', JSON.stringify({ username, password }), this.httpOptions)
            .pipe(
                map(res => {
                    return res;
            }),
                catchError(this.handleError)
            );
    }

    updatePATAToken(id, compileToken, compileExpiration, compileAuth, compileSUB, compileISS): Observable<any> {
        this.updateHeaders();

        return this._http.put('/api/v1/tokens/pata/' + id, JSON.stringify({ compileToken, compileExpiration, compileAuth, compileSUB, compileISS}), this.httpOptions)
            .pipe(
                map( res => {
                    return res;
                }),
                    catchError(this.handleError)
            );
    }

    deletePATAToken(id): Observable<any> {
        return this._http.delete('/api/v1/tokens/pata/' + id, this.httpOptions)
        .pipe(
            catchError(this.handleError)
        );
    }

    getUserPerArea(): Observable<any> {

        return this._http.get('/api/v2/users' , this.httpOptions )
                .pipe(
                    retry(3),
                    map(res => {
                        return res;
                    }),
                    catchError(this.handleError));
    }

    getAreas(): Observable<Array<Area>> {

        return this._http.get<Array<Area>>('/api/v2/area', this.httpOptions )
                .pipe(
                    retry(3),
                    map(res => {
                        return res;
                    }),
                    catchError(this.handleError));
    }

    refreshSessionArea(): Observable<void> {
        return this._http.get<any>('/api/v2/users/me', this.httpOptions)
            .pipe(
                map(res => {
                    if (!res) { return; }
                    this.userToken.area = res.area || '';
                    this.userToken.areaID = res.areaId || '';
                    this.userToken.restricted = res.areaRestricted;
                    this.userToken.tribeID = res.tribeId || '';
                    this.userToken.tribeName = res.tribeName || '';
                    sessionStorage.setItem('TribeID', this.userToken.tribeID ?? '');
                    sessionStorage.setItem('Tribe', this.userToken.tribeName ?? '');
                    sessionStorage.setItem('Area', this.userToken.area);
                    sessionStorage.setItem('AreaID', this.userToken.areaID);
                    sessionStorage.setItem('Restricted', String(this.userToken.restricted));
                    if (Array.isArray(res.roles)) {
                        this.sRoles = res.roles;
                        this.userToken.role = this.checkMainRole(res.roles);
                        sessionStorage.setItem('Roles', JSON.stringify(res.roles));
                        sessionStorage.setItem('Role', this.userToken.role);
                    }
                    this.sessionAreaChanged.next();
                }),
                catchError(() => of(void 0))
            );
    }

    getAreaName(id: string) {
        let areaIndex;
        let areaName;
        areaIndex = this.workAreas.find(obj => obj.id === id);
        areaIndex = this.workAreas.indexOf(areaIndex);
        if ( areaIndex > -1 ) {
            areaName = this.workAreas[areaIndex].area;
        } else {
            areaName = '';
        }

        return areaName;
    }

    changeArea (username, area): Observable<any> {

        // username fica por compatibilidade: o v2 altera sempre a area do proprio usuario logado
        return this._http.patch<any>('/api/v2/users/me/area', JSON.stringify({area}), this.httpOptions)
            .pipe(
                map( res => {
                    this.userToken.area = res?.areaName || area;
                    this.userToken.areaID = res?.area || '';
                    sessionStorage.setItem('Area', this.userToken.area);
                    sessionStorage.setItem('AreaID', this.userToken.areaID);
                    return res;
                }),
                    catchError(this.handleError)
            );
    }

    checkToken (): boolean {
        if (this.userToken.token !== null && this.userToken.token !== '' && this.userToken.token !== undefined ) {
            return true;
        } else {
            this.validSession();
            if (this.userToken.token !== null && this.userToken.token !== '' && this.userToken.token !== undefined ) {
                this.updateHeaders();
                return true;
            }
            console.error('YOU SHALL NOT PASS!');
            return false;
        }
    }

    checkArea (){
        if (this.userToken.area !== null && this.userToken.area !== '' && this.userToken.area !== undefined ) {
                return true;
        } else {
            return false
        }

    }

    checkMainRole(roles) {
        let mainRole: string = '';

        if (roles.includes('superuser')) {
            mainRole = 'superuser';
        } else {
            if (roles.includes('team')) {
                mainRole = 'team';
            } else {
                mainRole = 'user'
            }
        }
         return mainRole;
    }
    // - LOGIN --------------------------------------------------------------------------------------------------------

    // - ACTION ------------------------------------------------------------------------------------------
    getActionsbyName (login): Observable<any> {
        return this._http.get('/api/v1/actions?username=' + login, this.httpOptions )
                    .pipe(
                            retry(3),
                            map(actions => {
                                return actions;
                            }),
                            catchError(this.handleError));
    }

    getActionsbyType (type): Observable<any> {
        return this._http.get('/api/v1/actions?actionType=' + type, this.httpOptions )
                    .pipe(
                            retry(3),
                            map(actions => {
                                return actions;
                            }),
                            catchError(this.handleError));
    }

    getActionsbyResource (resourceId): Observable<any> {
        return this._http.get('/api/v1/actions?resourceId=' + resourceId, this.httpOptions )
                    .pipe(
                            retry(3),
                            map(actions => {
                                return actions;
                            }),
                            catchError(this.handleError));
    }

    createAction (name, expirationDays, recipeId): Observable<any> {
        return this._http.post('/api/v1/actions', JSON.stringify({ name, expirationDays, recipeId }), this.httpOptions)
            .pipe(
                map(res => {
                    return res;
            }),
                catchError(this.handleError)
            );
    }

    createLoginAction (username, description, resourceId): Observable<any> {
        return this._http.post('/api/v1/loginActions', JSON.stringify({ username, description, resourceId }), this.httpOptions)
            .pipe(
                map(res => {
                    return res;
            }),
                catchError(this.handleError)
            );
    }

    modifyLoginAction (id, username, recipeId): Observable<any> {

        return this._http.put('/api/v1/loginActions/' + id, JSON.stringify({username, recipeId}), this.httpOptions)
            .pipe(
                map( res => {
                    return res;
                }),
                    catchError(this.handleError)
            );
    }

    modifyAction (id, name, expirationDays): Observable<any> {

        return this._http.put('/api/v1/actions/' + id, JSON.stringify({name, expirationDays}), this.httpOptions)
            .pipe(
                map( res => {
                    return res;
                }),
                    catchError(this.handleError)
            );
    }

    deleteAction (id): Observable<any> {
        return this._http.delete('/api/v1/actions/' + id, this.httpOptions)
        .pipe(
            catchError(this.handleError)
        );
    }

    // - NOTIFICATION -------------------------------------------------------------------------------------------

    getNotifications(): Observable<any> {
        return this._http.get('/api/v1/notifications', this.httpOptions)
            .pipe(map( res => res), catchError(this.handleError));
    };

    readNotification(id): Observable<any> {
        return this._http.put('/api/v1/notifications/' + id, {seen: true}, this.httpOptions)
            .pipe(map(res => res), catchError(this.handleError));
    }

    handleError( error: HttpErrorResponse ) {
        if (error instanceof ErrorEvent) {
            console.error('Erro ocorrido: ', error);
        } else {
            console.error( 'O servidor te ignorou e respondeu ' + error.status + ' e ainda disse: ' + error.message  );            
        }
        return throwError(() => new Error('I have a bad feeling about this...' + error.status + ' and that ' + error.message)) 
    }

    ///--------------- PAINEL ADMINISTRATIVO ---------------------------------------------------------------------------

    getResumeAnalyzeDBs (): Observable<any> {
        return this._http.get('/api/v1/resources/AnalyzeDBs/resume', this.httpOptions )
                    .pipe(
                            retry(3),
                            map(resume => {
                                return resume
                            }),
                            catchError(this.handleError));
    }

    runAnalyzeDBs (): Observable<any> {
        return this._http.get('/api/v1/resources/AnalyzeDBs/run', this.httpOptions )
                    .pipe(
                            retry(3),
                            map(resume => {
                                return resume;
                            }),
                            catchError(this.handleError));
    }

    /// ----------------------------------------------------------------------------------------------------------------


    getMenu (): Observable<any> {
        return this._http.get<any[]>('/api/v1/menuRoutes', this.httpOptions )
                    .pipe(
                            retry(3),
                            map((menu: any[]) => {
                                return menu.sort((a: any, b: any) => {
                                    // Items with label '' should come first
                                    if (a.label === '' && b.label !== '') return -1;
                                    if (a.label !== '' && b.label === '') return 1;
                                    return 0;
                                });
                            }),
                            catchError(this.handleError));
    }
}
